import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../../material/material.module';
import { PlayerTagViewModel } from '../../../shared/models/player.model';

interface SelectPlayerTagDialogData {
  tags: PlayerTagViewModel[];
}

@Component({
  selector: 'app-select-player-tag-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModule, MatDialogModule],
  templateUrl: './select-player-tag-dialog.component.html',
  styleUrl: './select-player-tag-dialog.component.css'
})
export class SelectPlayerTagDialogComponent {
  selectedTagId: string = '';

  constructor(
    public dialogRef: MatDialogRef<SelectPlayerTagDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectPlayerTagDialogData
  ) {}

  save(): void {
    this.dialogRef.close(this.selectedTagId || null);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
